import { id_pkix } from "@peculiar/asn1-x509";
export const id_pda = `${id_pkix}.9`;
export const id_qcs = `${id_pkix}.11`;
